import { normalize } from 'normalizr';

import { objectListSchema, objectSchema } from 'api/normalize/schemas'


import { auth } from 'utils';

import {
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAILURE,
  CHECK_CHECKBOX,
  CHECK_CHECKBOXES,
  CLEAR_SELECTIONS,
  CLOSE_MODAL,
  DELETE_OBJECTS,
  DELETE_OBJECTS_SUCCESS,
  DELETE_OBJECTS_FAILURE,
  GET_OBJECT_DOWNLOAD,
  GET_OBJECT_DOWNLOAD_SUCCESS,
  GET_OBJECT_DOWNLOAD_FAILURE,
  GET_OBJECTS,
  GET_OBJECTS_SUCCESS,
  GET_OBJECTS_FAILURE,
  GET_OBJECT,
  GET_OBJECT_SUCCESS,
  GET_OBJECT_FAILURE,
  GET_DELETED_OBJECTS,
  GET_DELETED_OBJECTS_SUCCESS,
  GET_DELETED_OBJECTS_FAILURE,
  LOGIN,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  FILE_DOWNLOAD,
  FILE_UPLOADING,
  FILE_UPLOADING_SUCCESS,
  FILE_UPLOADING_CANCELLED,
  FILE_UPLOADING_PROGRESS,
  FILE_UPLOADING_FAILURE,
  INITIALIZE,
  INITIALIZE_SUCCESS,
  INITIALIZE_FAILURE,
  STAR_OBJECT,
  STAR_OBJECT_SUCCESS,
  STAR_OBJECT_FAILURE,
  UNSTAR_OBJECT,
  UNSTAR_OBJECT_SUCCESS,
  UNSTAR_OBJECT_FAILURE,
  RESTORE_OBJECTS,
  RESTORE_OBJECTS_SUCCESS,
  RESTORE_OBJECTS_FAILURE,
  SEARCH,
  SEARCH_SUCCESS,
  SEARCH_FAILURE,
  UNCHECK_CHECKBOX,
  UNCHECK_CHECKBOXES,
  UPDATE_OBJECT_NAME,
  UPDATE_OBJECT_NAME_SUCCESS,
  UPDATE_OBJECT_NAME_FAILURE,
  UPDATE_PASSWORD,
  UPDATE_PASSWORD_SUCCESS,
  UPDATE_PASSWORD_FAILURE,
  VERIFY_INITIALIZATION,
  VERIFY_INITIALIZATION_SUCCESS,
  VERIFY_INITIALIZATION_FAILURE,
  SHOW_MODAL,
} from '../../constants/ActionTypes'

import { GET, PUT, POST } from '../crud';

import { client} from '../client';

import populate from './populate';

import getDownloadUrl from '../helpers/getDownloadUrl';

const CancelToken = client.CancelToken;


export const downloadFile = (info = {}) => async (dispatch, getState) => {
  dispatch({
    type: FILE_DOWNLOAD,
    ...info
  });
};

export const deleteObjects = (info = {}) => async (dispatch, getState) => {
  dispatch({
    type: DELETE_OBJECTS,
  });

  const { ids = [] } = info;

  try {
    await Promise.all(
      ids.map(id => POST(`/objects/${id}/delete`, { config: { auth: auth.getAuth() } }))
    );

    dispatch({
      type: DELETE_OBJECTS_SUCCESS,
      deletedIds: ids
    });
  } catch(e) {
    dispatch({
      type: DELETE_OBJECTS_FAILURE,
      errorMessage: e.message
    });
  }
}

export const getDeletedObjects = (info = {}) => async (dispatch, getState) => {
  const { page, prefix } = info;

  dispatch({
    type: GET_DELETED_OBJECTS,
  });

  const params = {};

  if (page)
    params.page = page;

  if (prefix)
    params.prefix = prefix;

  try {
    const objects = await GET('deletedobjects', { params, auth: auth.getAuth() });

    dispatch({
      type: GET_DELETED_OBJECTS_SUCCESS,
      deletedObjects: objects,
    });

  } catch(e) {
    return  dispatch({
      type: GET_DELETED_OBJECTS_FAILURE,
      errorMessage: e.message
    })
  }
};

export const getObject = (info = {}, options = {}) => async (dispatch, getState) => {
  const { appendDownloadUrl } = options;
  const {type , ...state} = getState();

  const { id } = info;

  dispatch({
    type: GET_OBJECT,
  });


  try {
    const object = await GET(`objects/${id}/info`, { auth: auth.getAuth() });

    if (appendDownloadUrl) {
      try {
        const token = await GET(`objects/${id}/downloadtoken`, { auth: auth.getAuth() });
        object.downloadUrl = getDownloadUrl(token.token)
      } catch(e) {}
    }

    dispatch({
      type: GET_OBJECT_SUCCESS,
      ...normalize([object], objectListSchema)
    });

  } catch(e) {
    return  dispatch({
      type: GET_OBJECT_FAILURE,
      errorMessage: e.message
    })
  }
};

export const getObjects = (info = {}, { append = true } = {}) => async (dispatch, getState) => {
  const {type , ...state} = getState();

  const { page, folder_id: folder } = info;

  dispatch({
    type: GET_OBJECTS,
  });

  const params = {};

  if (page)
    params.page = page;

  try {
    let objects = []

    if (folder) {
      objects = await GET(`objects/${folder}/listing`, { params, auth: auth.getAuth() });
    } else {
      objects = await GET(`objects/listing`, { params, auth: auth.getAuth() });
    }

    dispatch({
      type: GET_OBJECTS_SUCCESS,
      ...normalize(objects, objectListSchema)
    });

  } catch(e) {
    return  dispatch({
      type: GET_OBJECTS_FAILURE,
      errorMessage: e.message
    })
  }
};

export const getObjectDownloadToken = (info) => async (dispatch, getState) => {
  const { id } = info;

  dispatch({
    type: GET_OBJECT_DOWNLOAD,
    id
  });

  try {
    let token = await GET(`objects/${id}/downloadtoken`, { auth: auth.getAuth() });

    dispatch({
      type: GET_OBJECT_DOWNLOAD_SUCCESS,
      downloadToken: token.token,
      id
    });

  } catch(e) {
    return  dispatch({
      type: GET_OBJECT_DOWNLOAD_FAILURE,
      errorMessage: e.message,
      id
    })
  }
};

export const initialize = (params = {}) => async (dispatch, getState) => {
  const authorization = auth.getAuth();

  const { email = authorization.username, password = authorization.password } = params;

  dispatch({
    type: INITIALIZE,
  });

  try {
    if (!email) {
      return  dispatch({
        type: INITIALIZE_FAILURE,
        errorMessage: 'Email required'
      })
    }

    if (!password) {
      return  dispatch({
        type: INITIALIZE_FAILURE,
        errorMessage: 'Password required'
      })
    }

    await POST('initializer/initialize', {
      body: { email, password },
      config: { auth: { username: email, password } },
    });

    await populate({ email, password });

    dispatch({
      type: INITIALIZE_SUCCESS,
      email,
      password
    });

  } catch(e) {
    let errorMessage = 'Something went wrong';

    return  dispatch({
      type: INITIALIZE_FAILURE,
      errorMessage
    })
  }
};

export const changePassword = (params = {}) => async (dispatch, getState) => {
  const { opassword, password } = params;
  const { username: email } = auth.getAuth();

  dispatch({
    type: CHANGE_PASSWORD,
  });

  try {
    if (!email) {
      return  dispatch({
        type: CHANGE_PASSWORD_FAILURE,
        errorMessage: 'Email required'
      })
    }

    if (!password) {
      return  dispatch({
        type: CHANGE_PASSWORD_FAILURE,
        errorMessage: 'Password required'
      })
    }

    if (!opassword) {
      return  dispatch({
        type: CHANGE_PASSWORD_FAILURE,
        errorMessage: 'Old Password required'
      })
    }

    await POST('users', {
      body: { email, opassword, password },
      config: { auth: auth.getAuth() },
    });

    dispatch({
      type: CHANGE_PASSWORD_SUCCESS,
    });

  } catch(e) {
    let errorMessage = 'Something went wrong';

    if (e.status === 401) {
      errorMessage = 'Invalid combination of username and password';
    }
    return  dispatch({
      type: CHANGE_PASSWORD_FAILURE,
      errorMessage
    })
  }
};

export const login = (params = {}) => async (dispatch, getState) => {
  const { email, password } = params;
  dispatch({
    errorMessage: '',
    type: LOGIN
  });

  try {
    if (!email) {
      return  dispatch({
        type: LOGIN_FAILURE,
        errorMessage: 'Email required'
      })
    }

    if (!password) {
      return  dispatch({
        type: LOGIN_FAILURE,
        errorMessage: 'Password required'
      })
    }

    await POST('users/login', {
      config: { auth: { username: email, password } },
    });

    localStorage.setItem('email', email);
    localStorage.setItem('password', password)

    dispatch({
      type: LOGIN_SUCCESS,
      email,
      password
    });

  } catch(e) {
    console.log(e)
    let errorMessage = 'Something went wrong';

    if (e.status === 401) {
      errorMessage = 'Invalid combination of username and password';
    }
    return  dispatch({
      type: LOGIN_FAILURE,
      errorMessage
    })
  }
};

export const restoreObjects = (info = {}) => async (dispatch, getState) => {
  dispatch({
    type: RESTORE_OBJECTS,
  });

  const { ids = [], overwrite } = info;

  try {
    const restors = await Promise.all(
      ids.map(async (id) => {
        try {
          await POST(`/deletedobjects/${id}/restore${overwrite ? '?overwrite=true' : ''}`, { config: { auth: auth.getAuth() } });

          return { id };
        } catch (e) {
          const error = { error: true, message: e.message }
          error.duplicate = e.status === 409;
          error.id = id;

          return error;
        }
      })
    );

    if (restors.some(val => val.error)) {
      dispatch({
        type: RESTORE_OBJECTS_FAILURE,
        errors: restors.filter(error => error.error),
        restoredIds: restors.filter(val => !val.error).map(val => val.id)
      });
    } else {  
      dispatch({
        type: RESTORE_OBJECTS_SUCCESS,
        restoredIds: ids,
      });
    }
  } catch(e) {
    dispatch({
      type: RESTORE_OBJECTS_FAILURE,
      errorMessage: e.message
    });
  }
}

export const search = (info = {}, requester) => async (dispatch, getState) => {
  dispatch({
    type: SEARCH,
  });

  try {
    const objects = await GET('objects/search', { params: info, auth: auth.getAuth() });

    dispatch({
      type: SEARCH_SUCCESS,
      ...normalize(objects, objectListSchema),
      requester
    });

  } catch(e) {
    return  dispatch({
      type: SEARCH_FAILURE,
      errorMessage: e.message
    })
  }
};

export const starObject = (info = {}) => async (dispatch, getState) => {
  const { id } = info;

  const staticResult = {
    id,
    starredKey: id
  }

  dispatch({
    type: STAR_OBJECT,
    ...staticResult
  });

  try {
    await POST(`objects/${id}/star`, {
      config: {
        auth: auth.getAuth()
      }
    });

    dispatch({
      type: STAR_OBJECT_SUCCESS,
      ...staticResult
    });

  } catch(e) {
    return  dispatch({
      type: STAR_OBJECT_FAILURE,
      errorMessage: e.message,
      ...staticResult
    })
  }
};

export const updateObjectName = (info = {}) => async (dispatch, getState) => {
  dispatch({
    type: UPDATE_OBJECT_NAME,
    ...info
  });

  const { id, name } = info;

  try {
    await POST(`objects/${id}/rename/${name}`, {
      config: {
        auth: auth.getAuth()
      }
    });

    dispatch({
      type: UPDATE_OBJECT_NAME_SUCCESS,
      ...info
    });
  } catch(e) {
    dispatch({
      type: UPDATE_OBJECT_NAME_FAILURE,
      errorMessage: e.message,
      ...info
    });
  }
}

export const unstarObject = (info = {}) => async (dispatch, getState) => {
  const { id } = info;

  const staticResult = {
    id,
    unstarredKey: id
  }

  dispatch({
    type: UNSTAR_OBJECT,
    starredKey: id,
    ...staticResult
  });

  try {
    await POST(`objects/${id}/unstar`, {
      config: {
        auth: auth.getAuth()
      }
    });

    dispatch({
      type: UNSTAR_OBJECT_SUCCESS,
      ...staticResult
    });

  } catch(e) {
    return  dispatch({
      type: UNSTAR_OBJECT_FAILURE,
      errorMessage: e.message,
      ...staticResult
    })
  }
};

export const uploadObject = (info = {}, { disableProgressAction } = {}) => async (dispatch, getState) => {
  const { file, id, index, prefix, overwrite } = info;
  const source = CancelToken.source();

  dispatch({
    type: FILE_UPLOADING,
    cancelUploadSource: source,
    fileId: id,
  });

  try {
    const onUploadProgress = (progressEvent) => {
      const percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );

      if (!disableProgressAction) {
        dispatch({
          type: FILE_UPLOADING_PROGRESS,
          fileProgress: percentCompleted,
          fileId: id,
          fileIndex: index
        });
      }
    };

    // this removes the starting slash or unwanted slashes
    const path = file.path ? file.path.split('/').filter(path => path).join('/') : file.name;

    const object = await PUT(`objects/${encodeURI(path)}?overwrite=${overwrite}`, {
      body: file,
      config: {
        auth: auth.getAuth(),
        onUploadProgress,
        cancelToken: source.token,
        headers: {'Content-Type': file.type}
      }
    });

    console.log('Uploaded file::', object)

    dispatch({
      type: FILE_UPLOADING_SUCCESS,
      fileId: id,
      fileIndex: index,
      fileName: file.name,
      ...normalize([object], objectListSchema)
    });

  } catch(e) {
    const dispatchObj = {
      errorMessage: e.message,
      fileId: id,
      fileIndex: index,
      fileName: file.name,
      fileDuplicate: e.status === 409
    };

    if (e.isCancelled) {
      dispatchObj.type = FILE_UPLOADING_CANCELLED;
    } else {
      dispatchObj.type = FILE_UPLOADING_FAILURE;
    }

    return dispatch(dispatchObj);
  }
};

export const updatePassword = (info = {}) => async (dispatch, getState) => {
  dispatch({
    type: UPDATE_PASSWORD,
  });

  const { oldPassword, newPassword } = info;

  try {
    if (!oldPassword || !newPassword) throw new Error('old or new password not provided');

    await POST('', {
      body: { oldPassword, newPassword },
    });

    dispatch({
      type: UPDATE_PASSWORD_SUCCESS,
    });
  } catch(e) {
    dispatch({
      type: UPDATE_PASSWORD_FAILURE,
      errorMessage: e.message
    });
  }
}

export const verifyInitialization = () => async (dispatch, getState) => {
  dispatch({
    type: VERIFY_INITIALIZATION,
  });

  try {
    const initialize = await GET('initializer/initialized');

    dispatch({
      type: VERIFY_INITIALIZATION_SUCCESS,
      initialize,
    });

  } catch(e) {
    // 401 means the DB has already been initalized.
    if (e.status === 401) {
      dispatch({
        type: VERIFY_INITIALIZATION_SUCCESS,
        initialize: { initialized: true, loginRequired: true },
      });
    } else {
      return  dispatch({
        type: VERIFY_INITIALIZATION_FAILURE,
        errorMessage: e.message
      })
    }
  }
};



//Local actions
export const closeModal = (info = {}) => async (dispatch) => {
  dispatch({
    type: CLOSE_MODAL,
    ...info
  });
};

export const checkCheckbox = (info = {}) => async (dispatch, getState) => {
  const state = getState();
  const newState = {}

  if (!state.selections || info.resetSelections) {
    newState.selections = new Set([])
  } else {
    newState.selections = new Set([...state.selections])
  }

  newState.selections.add(info.id)


  dispatch({
    type: CHECK_CHECKBOX,
    ...info,
    ...newState
  });
};

export const uncheckCheckbox = (info = {}) => async (dispatch, getState) => {
  const state = getState();
  const newState = {}

  if (info.resetSelections) {
    newState.selections = new Set([])
  } else if (state.selections) {
    newState.selections = new Set([...state.selections])
    newState.selections.delete(info.id);
  }

  dispatch({
    type: UNCHECK_CHECKBOX,
    ...info,
    ...newState
  });
};

export const checkCheckboxes = (info = {}) => async (dispatch, getState) => {
  const state = getState();
  const newState = {}

  if (info.ids) {
    if (!state.selections) {
      newState.selections = new Set([])
    } else {
      newState.selections = new Set([...state.selections])
    }

    info.ids.forEach(id => {
      newState.selections.add(id)
    })
  }


  dispatch({
    type: CHECK_CHECKBOXES,
    ...info,
    ...newState
  });
};

export const uncheckCheckboxes = (info = {}) => async (dispatch, getState) => {
  const state = getState();
  const newState = {}

  if (state.selections && info.ids) {
    newState.selections = new Set([...state.selections])

    info.ids.forEach(id => {
      newState.selections.delete(id);
    })
  }

  dispatch({
    type: UNCHECK_CHECKBOXES,
    ...info,
    ...newState
  });
};

export const clearSelections = () => async (dispatch) => {
  dispatch({
    type: CLEAR_SELECTIONS,
    selections: new Set([])
  });
};

export const showModal = (info = {}) => async (dispatch) => {
  dispatch({
    type: SHOW_MODAL,
    ...info
  });
};